/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import odata from '@bingads-webui-static-legacy/communication/channel/odata';
import resultsStatus from '@bingads-webui-static-legacy/schema/bulkEdit/resultsStatus';
import * as alertHelper from '@bingads-webui-campaign/alert-helper';
import templateConfig from '@bingads-webui-static-legacy/app/config/template';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
templateConfig.run();
var urlTmpls = _.mapObject({
  getJobs: '/Advertiser/Customers()/Accounts()/BulkEditSessions?$top={{top}}&$skip={{skip}}',
  getSingleJob: '/Advertiser/Customers()/{{accountInUrl ? \'Accounts()/\' : \'\'}}BulkEditSessions(\'{{jobId}}\')?',
  getJobResults: '/Advertiser/Customers()/{{accountInUrl ? \'Accounts()/\' : \'\'}}BulkEditSessions(\'{{jobId}}\')/BulkEditResults?$top={{top}}&$skip={{skip}}',
  filterSuffix: '&$filter={{statusFilter}}'
}, function (url) {
  return _.template(url);
}), exports = {};
function getHistory(skip, take) {
  return odata.get(urlTmpls.getJobs({
    skip: skip,
    top: take
  })).then(function (response) {
    return {
      items: _.map(response.value, mapJobObject),
      total: response['@odata.count']
    };
  }).catch(function (response) {
    var errors = response && response.errorResponseBody && response.errorResponseBody.value ? response.errorResponseBody.value : [];
    var isCustomerMigrationError = _.find(errors, function (item) {
      return item.Code === 'CustomerUnderMigration';
    });
    if (isCustomerMigrationError) {
      var alert = new alertHelper.AlertHelper({
        i18n: i18n
      });
      var migrationMsg = i18n.getString('Error_Campaign_API_CustomerUnderMigration');
      alert.showError(migrationMsg);
    }
  });
}
;
function mapJobObject(job) {
  return _.extend({}, job, {
    CreationTime: job.CreationTime && new Date(job.CreationTime),
    CompletionTime: job.CompletionTime && new Date(job.CompletionTime)
  });
}
function getJobs(jobModels) {
  if (!jobModels || jobModels.length === 0) {
    throw new Error('Provided Jobs array is empty or undefined');
  }
  var singleModel = jobModels.length === 1 ? jobModels[0] : null;
  if (singleModel) {
    return odata.get(urlTmpls.getSingleJob({
      jobId: singleModel.id,
      accountInUrl: singleModel.attributes.Entity !== 'Account'
    })).then(function (jobData) {
      return [mapJobObject(jobData)];
    });
  }
  return exports.getJobsByIds(_.pluck(jobModels, 'id'));
}
;
function getJobsByIds(jobIds) {
  return getHistory(0, 20).then(function (jobsData) {
    return _.filter(jobsData.items, function (job) {
      return _.contains(jobIds, job.Id);
    });
  });
}
function getJobResults(jobId, statusFilter, skip, take, entity) {
  var url = urlTmpls.getJobResults({
    jobId: jobId,
    top: take,
    skip: skip,
    accountInUrl: !entity || entity !== 'Account'
  });
  var filter = '';
  if (statusFilter === resultsStatus.OnlyErrors) {
    filter = 'Errors/any() or EditorialErrors/any()';
  } else if (statusFilter === resultsStatus.OnlySuccessful) {
    filter = 'not (Errors/any() or EditorialErrors/any())';
  }
  if (filter !== '') {
    url += urlTmpls.filterSuffix({
      statusFilter: filter
    });
  }
  return odata.get(url);
}
export default _.extend(exports, {
  getHistory: getHistory,
  getJobsByIds: getJobsByIds,
  getJobs: getJobs,
  getJobResults: getJobResults
});

